import { render, staticRenderFns } from "./achievementStudentRank.vue?vue&type=template&id=49141184&scoped=true"
import script from "./achievementStudentRank.vue?vue&type=script&lang=js"
export * from "./achievementStudentRank.vue?vue&type=script&lang=js"
import style0 from "./achievementStudentRank.vue?vue&type=style&index=0&id=49141184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49141184",
  null
  
)

export default component.exports